(function($){
  $(function(){
    // Show sidebar when enter to a reading lesson
    if(!Cookies.get(JS_SIDENAV_CLOSED_COOKIE_STATE)){
      $('#nav-mobile').removeClass('nav-hide');
      $('#collapse-button').addClass('is-opened');
    }

    // build `Table of content`
    var headers = $('.js-lesson-source').find('h2, h3');
    $.each(headers, function(index, header){
      var text = $(header).text();
      var slug = slugify(text);
      var a = $('<a>')
        .attr('href', '#' + slug)
        .text(text);
      var li = $('<li>').append(a);
      $('.js-dinamic-table-of-contents').append(li);

      $(header)
        .attr('id', slug)
        .addClass('scrollspy');
    });
    $('.scrollspy').scrollSpy();

    $('.js-finish-lesson-btn').on('click', function(e){
      if($(this).hasClass('disabled')){
          e.preventDefault();
      }
    });

    // Collapse lesson files
    $('.file-item').on('click', function(evt) {
      // don't collapse if file-download button was clicked
      if ($(evt.target).hasClass('file-download') || !($(evt.target).hasClass('file-name') || $(evt.target).hasClass('file-icon'))) {
        return;
      }

      if ($(this).find('.file-content').hasClass('collapsed')) {
        $(this).find('.file-content').removeClass('collapsed')
      } else {
        $(this).find('.file-content').addClass('collapsed')
      }
    });
  }); // end of document ready
})(jQuery); // end of jQuery name space

$(window).load(function(){
    // NOTE: Must be executed after window load, because body height
    //       is calculated dynamically

    // Pushpin right bar
    var tocWrapperHeight = 260; // Max height of ads.
    var tocHeight = $('.toc-wrapper .table-of-contents').length ? $('.toc-wrapper .table-of-contents').height() : 0;
    var socialHeight = 95; // Height of unloaded social media in footer.
    var footerOffset = $('body > footer').first().length ? $('body > footer').first().offset().top : 0;
    var footerTabs = $('.footer-tabs').height();
    var sbbHeight = $('.sidebar-buttons').height();
    var bottomOffset = footerOffset - socialHeight - tocHeight - tocWrapperHeight;
    // $('.toc-wrapper').pushpin({
    //     top: $('nav').height(),
    //     bottom: bottomOffset
    // });
});
